import { withStyles, withTheme } from "@material-ui/core";
import React, {memo} from "react";
import { compose } from "recompose";
import Tooltip from "../../../components/common/StyledToolTip";
import { PICKUP_MANAGEMENT_MODES } from "../../../components/modules/Dispatch/RouteExecution/Pickups/PickupManagement/constants";
import styles from "./styles";
import EditIcon from "@material-ui/icons/Edit";

class EditPickup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enable: false,
    };
    this.isPickupSelectionInvalid = false;
  }

  componentDidMount() {
    this.props.eventHub.on(
      `${this.props.headerId}_updatePickupManagementIconStatus`,
      this.changeEditPickupStatus
    );
  }

  componentWillUnmount() {
    this.props.eventHub.off(
      `${this.props.headerId}_updatePickupManagementIconStatus`,
      this.changeEditPickupStatus
    );
  }

  changeEditPickupStatus = ({ selectedPickups }) => {
    this.isPickupSelectionInvalid = selectedPickups.some(
      (pickup) => pickup.isCompleted || pickup.isVoided
    );
    const isEnabled = selectedPickups.length === 1 && !this.isPickupSelectionInvalid;
    this.setState({
      enable: isEnabled,
    });
  };

  getTooltipMessage = () => {
    if (this.isPickupSelectionInvalid || !this.props.enableEditPickup) {
      return "Edit Pickup (Disabled)";
    }
    if (this.state.enable) {
      return "Click to Edit Pickup";
    }
    return "Select a single pickup to Edit";
  };

  onEditPickupEvent = () => {
    if (this.state.enable) {
      this.props.eventHub.emit("pickupManagement", {
        action: PICKUP_MANAGEMENT_MODES.EDIT_PICKUP,
      });
    }
  };

  render() {
    const { classes, enableEditPickup } = this.props;
    const { enable } = this.state;
    return (
      <div
        className={`${classes.headerIconStyles} ${
          classes.iconLayout
        } glHeaderIcons ${
          enableEditPickup && enable ? classes.enabledIcon : classes.disableIcon
        }`}
        onClick={enableEditPickup && enable ? this.onEditPickupEvent : null}
      >
        <Tooltip title={this.getTooltipMessage()}>
          <EditIcon />
        </Tooltip>
      </div>
    );
  }
}

export default compose(withStyles(styles), withTheme())(memo(EditPickup));